import React, { useRef, useEffect, useState } from 'react';
import './Lander.css';
import Header from '../Header/Header';
import Chatroom from '../Chatroom/Chatroom';
import MChatroom from '../mChatroom/mChatroom';
import { Canvas, useFrame, useLoader, useThree } from '@react-three/fiber';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import * as THREE from 'three';
import { Text } from '@react-three/drei';

const Lander = () => {
    const [currentAnimation, setAnimation] = useState('sleeping');
    const [chatOpen, setChatOpen] = useState(false);
    const [showOverlay, setShowOverlay] = useState(true); // State for overlay
    const [isMobile, setIsMobile] = useState(false);
    const [mchatOpen, setmChatOpen] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for mobile user agents
        if (/android|ipad|iphone|ipod|windows phone|mobile/i.test(userAgent)) {
            setIsMobile(true);
        }
    }, []);

    if (isMobile) {
        return (
            <div className="mobile-blocker">
                <h1>Sorry, this site is not available on mobile devices.</h1>
                <p>Please visit us on a desktop or laptop device.</p>
            </div>
        );
    }

    const models = {
        femalelaying: '/models/FemaleLayingPose.fbx',
        flair: '/models/Flair.fbx',
        gangnam: '/models/Gangnam.fbx',
        shuffling: '/models/Shuffling.fbx',
        twerk: '/models/Twerk.fbx',
        booty: '/models/Booty.fbx',
        running: '/models/Running.fbx',
        sleeping: '/models/Sleeping.fbx',
    };

    const playBackgroundAudio = () => {
        const audio = new Audio('/music/chill.mp3'); // Path to your audio file
        audio.loop = true; // Loop audio
        audio.volume = 0.5; // Set volume
        audio.play().catch((error) => console.error('Audio play error:', error));
    };

    const handleOverlayClick = () => {
        setShowOverlay(false); // Hide the overlay
        playBackgroundAudio(); // Play the audio
    };

    const MoveCameraUp = () => {
        const { camera } = useThree();

        useEffect(() => {
            camera.position.y = 2.25;
            camera.position.z = 6.25;
            camera.updateProjectionMatrix();
        }, [camera]);

        return null;
    };

    const AnimatedModel = ({ path, scale = 0.015, rotation = [0.2, 0, 0] }) => {
        const model = useLoader(FBXLoader, path);
        const mixer = useRef(null);
        const ref = useRef();

        useEffect(() => {
            if (model.animations.length) {
                mixer.current = new THREE.AnimationMixer(model);
                const action = mixer.current.clipAction(model.animations[0]);
                action.play();
            }
        }, [model]);

        useFrame((state, delta) => {
            if (mixer.current) mixer.current.update(delta);
            if (ref.current) {
                ref.current.rotation.y += 0;
            }
        });

        return <primitive rotation={rotation} ref={ref} object={model} scale={scale} />;
    };

    const MultiTileFloor = () => {
        const tileCount = 11;
        const tileSize = 3;
        const tiles = useRef([]);
        const timeRef = useRef(0);

        const palette = ['#000000', '#000000', '#000000', '#000000', '#000000'];

        useFrame((state, delta) => {
            timeRef.current += delta;
            if (timeRef.current >= 0.35) {
                tiles.current.forEach((tile) => {
                    if (tile) {
                        const color = new THREE.Color(
                            palette[Math.floor(Math.random() * palette.length)]
                        );
                        tile.material.color.set(color);
                    }
                });
                timeRef.current = 0;
            }
        });

        const gridTiles = Array.from({ length: tileCount * tileCount }, (_, i) => {
            const row = Math.floor(i / tileCount);
            const col = i % tileCount;

            return (
                <mesh
                    key={i}
                    position={[
                        (col - tileCount / 2) * tileSize + 1,
                        -1,
                        (row - tileCount / 2) * tileSize,
                    ]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    ref={(el) => (tiles.current[i] = el)}
                >
                    <planeGeometry args={[tileSize, tileSize]} />
                    <meshStandardMaterial color="#ffffff" />
                </mesh>
            );
        });

        return <>{gridTiles}</>;
    };

    return (
        <div className="Lander">
            {showOverlay && (
                <div className="overlay" onClick={handleOverlayClick}>
                    <span className="overlay-text">Click to Begin</span>
                </div>
            )}
            <Header />
            <div className="Lander-Content">
                <Canvas
                    style={{ width: '100%', height: '800px', position: 'absolute', zIndex: 1 }}
                    gl={{
                        toneMapping: THREE.ACESFilmicToneMapping,
                        toneMappingExposure: 0.1,
                    }}
                >
                    <MoveCameraUp />
                    <MultiTileFloor />
                    <ambientLight intensity={18.3} color="#ffffff" />
                    {models[currentAnimation] ? (
                        <AnimatedModel path={models[currentAnimation]} scale={0.02} />
                    ) : (
                        <p>Model not found</p>
                    )}
                </Canvas>
                <button
                    onClick={() => {
                        setChatOpen(!chatOpen);
                    }}
                    className="Lander-Content-Button"
                >
                    <img className="Lander-Content-Button-Img" src={'/images/chatIMG.png'} />
                </button>
                <button onClick = {() => {setmChatOpen(!mchatOpen)}} className = 'Lander-Content-Chat'>
                    <img className = 'Lander-Content-Chat-Img' src = '/images/banana.png' />
                </button>
                <div className = 'Lander-Content-MarketCap'>
                    <span className = 'Lander-Content-MarketCap-Text'>Market Cap: $7.0K / 1.0M</span>
                    <div className = 'Lander-Content-MarketCap-Meter'>
                        <div className = 'Lander-Content-MarketCap-Meter-Inside'></div>
                    </div>
                </div>
                <span className = 'Lander-Content-Version'>version 1.0.2</span>
                {chatOpen ? <Chatroom /> : null}
                {mchatOpen ? <MChatroom /> : null}
                <span className="Lander-Content-MainText">The party hasn't started yet...</span>
            </div>
        </div>
    );
};

export default Lander;
